<script setup lang="ts">
import { CheckCircleIcon } from '@heroicons/vue/24/outline';
import { useAuthStore } from '~/stores/auth.store';
import { useSiteStore } from '~/stores/site.store';

defineProps<{ successType: 'password' | 'number' }>();

const auth = useAuthStore();
const site = useSiteStore();

const navigateToLogin = () => {
  site.deactivateModal();
  auth.logout({ reload: true, redirect: true, path: '/?login=1' });
};
</script>
<template>
  <div @keyup.enter="navigateToLogin">
    <div class="flex flex-col items-center">
      <CheckCircleIcon
        class="w-16 dark:text-primary-blue-600 text-primary-blue-400 icon-success--border-lg text-center"
      />
      <p
        class="mt-1 mb-2 dark:text-primary-blue-600 text-primary-blue-400 font-bold text-center"
      >
        {{ $t(`change-${successType}-success`) }}
      </p>
    </div>
    <div class="text-sm w-full p-4 bg-base fle">
      <DesignSystemButton
        class="w-full justify-center text-sm"
        rounding="lg"
        @click="navigateToLogin()"
      >
        {{ $t('login') }}
      </DesignSystemButton>
    </div>
  </div>
</template>
